export default __webpack_public_path__ + "static/poele-a-granules-48baf13ef6388111fbb50610f498706c.jpg";